"use strict";import{tag as a}from"../custom-tag.js";export function checkCircledReIcon({height:e=16,width:l=16,hidden:r=!1,title:t="Check circled re"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 80 80"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <path
        fill="currentColor"
        d="M40 70.75a30.725 30.725 0 0 0 25.097-48.484l5.448-5.75-1.09-1.032-5.269 5.562A30.74 30.74 0 1 0 40 70.75m0-60a29.21 29.21 0 0 1 23.145 11.395l-29.16 30.78L20.53 39.47l-1.06 1.06 14 14a.75.75 0 0 0 .53.22h.01a.75.75 0 0 0 .535-.234l29.502-31.141A29.238 29.238 0 1 1 40 10.75"
      />
    </svg>
  `}
//# sourceMappingURL=checkCircledRe.js.map
